import { useAppDispatch, setShouldShowMigrationToSNModal } from 'src/store';
import { useCallback, useMemo } from 'react';

export const useMigrationToSNModalActions = () => {
  const dispatch = useAppDispatch();

  const changeShouldShowMigrationToSNModal = useCallback(
    (value: boolean) => {
      dispatch(setShouldShowMigrationToSNModal(value));
    },
    [dispatch],
  );

  return useMemo(
    () => ({
      changeShouldShowMigrationToSNModal,
    }),
    [changeShouldShowMigrationToSNModal],
  );
};
